<template>
  <div v-if="items == null"></div>
  <div class="" v-else>
    <nav class="flex my-2">
      <ol
        class="inline-flex items-center space-x-1 md:space-x-3 text-[10px] md:text-sm font-medium"
      >
        <li class="inline-flex items-center">
          <nuxt-link
            to="/"
            class="inline-flex items-center text-medium hover:text-strong dark:text-white dark:hover:text-gray-500"
          >
            <svg
              class="w-3 h-3 mx-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"
              />
            </svg>
            Inicio
          </nuxt-link>
        </li>
        <li v-for="item in items">
          <div class="flex items-center gap-2">
            <svg
              class="w-2 h-2 text-gray-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 9 4-4-4-4"
              ></path>
            </svg>
            <nuxt-link
              :to="item.href"
              class="inline-flex items-center dark:text-white dark:hover:text-gray-500"
              :class="item.disabled ? 'text-gray-400 dark:text-gray-600 ' : null"
              @click="useOoloja.setMenuItem(null)"
              v-if="!item.disabled"
            >
              {{ item.title }}
            </nuxt-link>
            <span class="dark:text-gray-600" v-else>{{ item.title }}</span>
          </div>
        </li>
      </ol>
    </nav>
  </div>
</template>

<script setup>
import { useStoreOoloja } from "@/stores/ooloja";
const useOoloja = useStoreOoloja();

const { items } = defineProps(["items"]);
</script>

<style lang="scss" scoped>
$breadcrumbs-item-icon-font-size: 32rem;
</style>
